<template>
<!-- 三大服务 -->
    <div class="threeBox">
        <div class="threeList">
            <img class="pic" src="../assets/icon_touxiang 31@2x.png" alt="pic">
            <div class="text">
                <p>眼科医学专家</p>
                <p>开放时间:周三上午9:00~10:00</p>
            </div>
            <div class="details">
                <router-link :to="{ name: 'Eye' }">详情信息</router-link>
            </div>
        </div>

        <div class="threeList">
            <img class="pic" src="../assets/icon_touxiang 2@2x.png" alt="pic">
            <div class="text">
                <p>近视防控、膳食营养</p>
                <p>开放时间:周五下午17:00~18:00</p>
            </div>
            <div class="details">
                <router-link :to="{ name: 'Myopia' }">详情信息</router-link>
            </div>
        </div>

        <div class="threeList">
            <img class="pic" src="../assets/icon_touxiang 3@2x.png" alt="pic">
            <div class="text">
                <p>配镜服务专家</p>
                <p>开放时间:周一到周五9:00~18:00</p>
            </div>
            <div class="details">
                <router-link :to="{ name: 'Optician' }">详情信息</router-link>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {

    },
    data() {
        return {

        };
    },
    computed: {

    },
    created() {

    },
    mounted() {

    },
    watch: {

    },
    methods: {

    },
    components: {

    },
};
</script>

<style scoped>

p {
    font-size: 48px;
}


.threeBox {
    margin: 28px 0 0 0;
}

.threeList {
    height: 422px;
    padding: 28px;
    margin: 28px;
    border-radius: 25px;
    text-align: center;
    background: #fff;
}

.threeList .pic {
    width: 150px;
    height: 150px;
    /* background: #39495c; */
    border-radius: 50%;
    margin: 0 auto;
    margin-bottom: 30px;
}

.threeList .text {
    margin-left: 16px;
}

.threeList .text p:last-child {
    color: rgb(102, 102, 102);
    font-size: 36px;
    margin: 30px 0 10px;
    letter-spacing: 1px;
}

.threeList .details{
    height: 96px;
    line-height: 96px;
    margin-left: auto;
}

.threeList .details a {
    color: #39495c;
    font-size: 32px;
    width: 188px;
    display: inline-block;
    height: 72px;
    line-height: 72px;
    border: 2px solid #39495c;
    border-radius: 50px;
}
</style>



// WEBPACK FOOTER //
// src/views/ThreeServices.vue